export default __webpack_public_path__ + "static/regular-8a118c86fab59ba372367c685af800e7.woff";